/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) {
      id
      reportId
      stripePaymentId
      amount
      data
      createdAt
      updatedAt
    }
  }
`;
export const listPayments = /* GraphQL */ `
  query ListPayments(
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reportId
        stripePaymentId
        amount
        data
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReport = /* GraphQL */ `
  query GetReport($id: ID!) {
    getReport(id: $id) {
      id
      reportType
      year
      slug
      inputFile
      validatedFile
      dataImportMethod
      hrisProvider
      currentStep
      headQuarterFullAddress
      oneschemaSessionToken
      oneschemaData
      oneschemaSessionTokenExpiredTime
      priceCents
      owner
      paid
      resultGenerated
      snapshotStartDate
      snapshotEndDate
      hrisDataSyncing
      hrisDataResynced
      createdAt
      updatedAt
    }
  }
`;
export const listReports = /* GraphQL */ `
  query ListReports(
    $filter: ModelReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reportType
        year
        slug
        inputFile
        validatedFile
        dataImportMethod
        hrisProvider
        currentStep
        headQuarterFullAddress
        oneschemaSessionToken
        oneschemaData
        oneschemaSessionTokenExpiredTime
        priceCents
        owner
        paid
        resultGenerated
        snapshotStartDate
        snapshotEndDate
        hrisDataSyncing
        hrisDataResynced
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reportsByReportType = /* GraphQL */ `
  query ReportsByReportType(
    $reportType: String!
    $sortDirection: ModelSortDirection
    $filter: ModelReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportsByReportType(
      reportType: $reportType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportType
        year
        slug
        inputFile
        validatedFile
        dataImportMethod
        hrisProvider
        currentStep
        headQuarterFullAddress
        oneschemaSessionToken
        oneschemaData
        oneschemaSessionTokenExpiredTime
        priceCents
        owner
        paid
        resultGenerated
        snapshotStartDate
        snapshotEndDate
        hrisDataSyncing
        hrisDataResynced
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reportsByYear = /* GraphQL */ `
  query ReportsByYear(
    $year: Int!
    $sortDirection: ModelSortDirection
    $filter: ModelReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportsByYear(
      year: $year
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportType
        year
        slug
        inputFile
        validatedFile
        dataImportMethod
        hrisProvider
        currentStep
        headQuarterFullAddress
        oneschemaSessionToken
        oneschemaData
        oneschemaSessionTokenExpiredTime
        priceCents
        owner
        paid
        resultGenerated
        snapshotStartDate
        snapshotEndDate
        hrisDataSyncing
        hrisDataResynced
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reportsBySlug = /* GraphQL */ `
  query ReportsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportType
        year
        slug
        inputFile
        validatedFile
        dataImportMethod
        hrisProvider
        currentStep
        headQuarterFullAddress
        oneschemaSessionToken
        oneschemaData
        oneschemaSessionTokenExpiredTime
        priceCents
        owner
        paid
        resultGenerated
        snapshotStartDate
        snapshotEndDate
        hrisDataSyncing
        hrisDataResynced
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reportsByOwner = /* GraphQL */ `
  query ReportsByOwner(
    $owner: String!
    $sortDirection: ModelSortDirection
    $filter: ModelReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reportsByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportType
        year
        slug
        inputFile
        validatedFile
        dataImportMethod
        hrisProvider
        currentStep
        headQuarterFullAddress
        oneschemaSessionToken
        oneschemaData
        oneschemaSessionTokenExpiredTime
        priceCents
        owner
        paid
        resultGenerated
        snapshotStartDate
        snapshotEndDate
        hrisDataSyncing
        hrisDataResynced
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJobCategoryMapping = /* GraphQL */ `
  query GetJobCategoryMapping($id: ID!) {
    getJobCategoryMapping(id: $id) {
      id
      mappingJSON
      owner
      createdAt
      updatedAt
    }
  }
`;
export const listJobCategoryMappings = /* GraphQL */ `
  query ListJobCategoryMappings(
    $filter: ModelJobCategoryMappingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobCategoryMappings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mappingJSON
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEstablishment = /* GraphQL */ `
  query GetEstablishment($id: ID!) {
    getEstablishment(id: $id) {
      id
      fullAddress
      establishmentName
      workAddressLine1
      workAddressLine2
      city
      state
      zipCode
      naicsCode
      majorActivity
      hasCPDRReportLastYear
      hasEEO1ReportLastYear
      owner
      createdAt
      updatedAt
    }
  }
`;
export const listEstablishments = /* GraphQL */ `
  query ListEstablishments(
    $filter: ModelEstablishmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEstablishments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fullAddress
        establishmentName
        workAddressLine1
        workAddressLine2
        city
        state
        zipCode
        naicsCode
        majorActivity
        hasCPDRReportLastYear
        hasEEO1ReportLastYear
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
